export const VnLocalizedStrings = {
  GlobalLabels: {
    Store: "Cửa hàng",
    Staff: "Nhân viên",
    Welcome: "Đăng nhập CMS",
    Balance: "Hạn mức",
    Carrier: "Nhà mạng",
    Topup: "Nạp",
    STT: "STT",
    All: "Tất cả",
    NoSort: "Không có",
    Close: "Đóng",
    Status: "Trạng thái",
    Phone: "Số điện thoại",
    Actions: "Hành động",
    Active: "Hoạt động",
    Inactive: "Không hoạt động",
    Deleted: "Xóa",
    TakePicture: "Chụp ảnh",
    Noti: "Thông báo",
    Search: "Tra cứu",
    Position: "Vị trí",
    Redo: "Xóa bộ lọc",
    Cancel: "Hủy",
    Error: "Lỗi",
    Confirmed: "Xác nhận",
    Detail: "Chi tiết",
    Create: "Thêm mới",
    Password: "Mật khẩu",
    PasswordConfirmed: "Xác nhận mật khẩu",
    Description: "Mô tả",
    Update: "Cập nhật",
    Address: "Địa chỉ",
    Partner: "Đối tác",
    Total: "Tổng cộng",
    NoPartner: "Không thuộc đối tác",
    createdAt: "Ngày tạo",
    updatedAt: "Ngày cập nhật",
    Cover: "Ảnh nền",
    Success: "Thành công",
    Failed: "Thất bại",
    Date: "Ngày",
    Hour: "Giờ",
    ExcelExporting: "Xuất Excel",
    Type: "Loại",
    Name: "Tên",
    Regions: "Vùng",
    Login: "Đăng nhập",
    NoInfo: "Không có thông tin",
    ASC: "Tăng dần",
    DESC: "Giảm dần",
    Logout: "Đăng xuất",
    Attention: "Xem lưu ý tại đây",
    ReloadImages: "Làm mới ảnh",
    DownloadImage: "Tải ảnh",
    Placeholder: "Nhập ",
    Choose: "Chọn ",
    Images: "Hình ảnh",
    UserName: "Tên người dùng",
    Email: "Email",
    Order: "STT",
    Loading: "Đang tải...",
    Time: "Thời gian",
    Yes: "Có",
    No: "Không",
    Download: "Tải xuống",
    User: "Người dùng",
    Config: "Cấu hình",
    Save: "Lưu",
    Edit: "Chỉnh sửa",
    Supplier: "Nhà cung cấp",
    SupplierType: "Loại NCC",
    Import: "Nhập",
    ChangeStatus: "Đổi trạng thái",
    AccountManagement: "Quản lý tài khoản",
  },
  GlobalMessage: {
    Email: "Nhập đúng định dạng Email !",
    UpdateSuccessfully: "Cập nhật thành công !",
    UpdateFailed: "Cập nhật thất bại:",
    CreateSuccessfully: "Tạo mới thành công !",
    CreateFailed: "Tạo mới thất bại:",
    DeleteSuccessfully: "Xóa thành công !",
    DeleteFailed: "Xóa thất bại:",
    DeleteConfirmation: "Xác nhận xóa phần tử này ?",
    ResetPassSuccessfully: "Đặt lại mật khẩu thành công !",
    ResetPassFailed: "Đặt lại mật khẩu thất bại:",
    Error: "Đã có lỗi xảy ra",
    Exporting: "Đang xuất Báo cáo...",
    SystemError:
      "Có lỗi lấy thông tin đăng nhập hoặc token hết hạn, quay lại trang đăng nhập...",
    LoginSuccessfully: "Đăng nhập thành công !",
    InvalidAccount:
      "Username hoặc mật khẩu không đúng hoặc User không tồn tại !",
    InvalidMenuConfig:
      "Lỗi không lấy được Menu Sidebar, vui lòng thử lại sau !",
    Supplier: "Vui lòng nhập Mã tham chiếu",
    ChooseSupplier: "Vui lòng chọn Nhà cung cấp",
    Required: "Vui lòng nhập thông tin này",
    CannotAccessCam: "Không thể truy cập máy ảnh",
    SavingForLogin: "Giữ cho lần đăng nhập tiếp theo",
    SavedToClipboard: "Đã lưu giá trị vào bộ nhớ tạm.",
    InvalidStore: "Chọn một cửa hàng",
  },
  GlobalPlaceholder: {
    UserName: "Nhập user name",
    Email: "Vui lòng nhập email...",
    Name: "Vui lòng nhập tên...",
    Code: "Vui lòng nhập mã...",
    Partner: "Vui lòng chọn đối tác",
    Status: "Vui lòng chọn trạng thái",
    Phone: "Vui lòng nhập số điện thoại...",
    Password: "Nhập mật khẩu",
    PasswordConfirmed: "Mật khẩu xác nhận cần trùng với mật khẩu",
    Description: "Vui lòng nhập mô tả là chữ",
    Type: "Vui lòng chọn loại",
  },
  GlobalTotalSummary: {
    Success: "Thành công",
    Error: "Thất bại",
    Other: "Khác",
    Revenue: "Tổng doanh thu",
  },
  GlobalService: {
    SIM_ECOMMERCE: "SIM",
    TRAVEL_SIM: "SIM Du lịch",
    NICE_SIM: "SIM Số đẹp",
    BUY_PACKAGE: "Gói cước",
    AIR_TIME: "Nạp tiền ĐT",
    ALL: "Tất cả",
  },
  TopupInfo: {
    Title: "Thông tin chuyển khoản",
    AccountName: "Tên tài khoản",
    AccountNo: "Số tài khoản",
    Bank: "Ngân hàng",
    BankName: "Ngân Hàng TMCP Đầu tư và Phát triển Việt Nam - CN Bắc Sài Gòn",
    BankAddress:
      "290 Nam Kỳ Khởi Nghĩa, Phường Xuân Hòa, TP Hồ Chí Minh, Việt Nam",
    BankBranch: "Thủ Thiêm, PGD Cao Thắng",
  },
  Sidebar: {
    General: "Tổng quan",
    Management: "Quản lý",
    History: "Lịch sử giao dịch",
    DataTransaction: "Gói cước",
    SystemConfig: "Cấu hình hệ thống",
    DataPackages: "Gói cước Data",
    RoamingPackages: "Gói cước Roaming",
    UserManagement: "Người dùng",
    AffiliateManagement: "Quản lý affiliate",
    OrderList: "Đơn hàng mua SIM",
    TravelSimList: "Đăng ký SIM Du lịch",
    Country: "Quốc gia",
    PlatformConfig: "Platform",
    Contents: "Bài viết",
    Files: "Tệp",
    CDN: "CDN",
    Address: "Tỉnh thành",
    TopUpForPackage: "Gói cước 4G/5G",
    TopupForSimEcommerce: "Gói cước SIM Mobifone",
    TopUpForTravelService: "Gói cước SIM Du lịch",
    Suppliers: "Nhà cung cấp",
  },
  General: {
    Title: "Tổng quan",
    Summary: "Tổng quan hoạt động kinh doanh",
    ByDate: "Theo ngày",
    ByWeek: "Theo tuần",
    ByMonth: "Theo tháng",
    Revenue: {
      Label: "Doanh thu",
      CompareWith: "so với",
      Transaction: "Sản lượng",
      CurrentDate: "hôm nay",
      CurrentMonth: "tháng này",
      LastMonth: "tháng trước đó",
      PreviousDate: "ngày hôm qua",
      LastMonthDate: "tháng trước",
      LastMonthBefore: "tháng trước đó",
      Day: "Doanh thu hôm nay",
      Week: "Doanh thu tuần này",
      Month: "Doanh thu tháng này",
      WeekOfYear: "Tuần",
    },
    Charts: {
      Title: "Báo cáo tổng hợp",
      Transaction: "Giao dịch",
      TotalRevenue: "Tổng doanh thu",
      SuccessTransaction: "Tổng giao dịch thành công",
    },
  },
  UserManagement: {
    MainTitle: "Quản lý user hệ thống",
    Total: "Tổng User",
    Domestic: "Nội tệ",
    Foreign: "Ngoại te65",
    UserType: {
      Agency: "Chuỗi",
      Store: "Cửa hàng",
      Employee: "Nhân viên",
    },
    Labels: {
      Account: "Tài khoản",
      Authorize: "Uỷ quyền",
    },
    StaffColumns: {
      name: "Tên",
      fullName: "Họ tên",
      code: "Mã",
      phone: "Số điện thoại",
      email: "Email",
      address: "Địa chỉ",
      type: "Loại",
      role: "Role",
      wallet: "Số dư hiện tại",
      status: "Trạng thái",
    },
    Columns: {
      UserName: "Tên username",
      FullName: "Họ tên",
      Email: "Email",
      Partner: "Đối tác",
      Phone: "Số điện thoại",
      Balance: "Số dư",
      Role: "Role user",
      ResetPass: "Đặt mật khẩu mới",
      OldPass: "Mật khẩu cũ",
      NewPass: "Mật khẩu mới",
    },
    RuleMessage: {
      Url: "Vui lòng nhập link dưới dạng URL HTTPS",
      Name: "Vui lòng nhập tên",
      Password: "Vui lòng nhập mật khẩu",
      UserName: "Vui lòng nhập username",
      IdUrl: "Vui lòng nhập link tiếp thị",
      IconUrl: "Vui lòng nhập link icon có định dạng jpg, png, jpeg",
      Status: "Vui lòng chọn trạng thái",
      Phone: "Vui lòng nhập số điện thoại gồm 10 chữ số",
      Code: "Vui lòng nhập mã",
      Role: "Vui lòng chọn role cho user",
      Partner: "Vui lòng chọn đối tác ( tùy chọn )",
      InvalidPartner: "Đối tác không hợp lệ",
      Balance: "Vui lòng nhập hạn mức",
      AuthorizeSuccess: "Ủy quyền thành công, đang chuyển hướng...",
    },
  },
  PathConfigManagement: {
    Title: "Quản lý cấu hình",
    Total: "Tổng cộng",
    Columns: {
      Title: "Tên cấu hình",
      Code: "Mã cấu hình",
      Path: "Đường dẫn",
      ImageUrl: "Hình ảnh",
      Description: "Mô tả",
    },
    Placeholder: {
      Title: "Vui lòng nhập tên",
      Path: "Vui lòng nhập đường dẫn",
      ImageUrl: "Vui lòng nhập link hình ảnh dạng URL",
      Description: "Vui lòng nhập mô tả",
    },
    Message: {
      AddConfig: "Vui lòng khai báo cấu hình JSON bên dưới",
    },
  },
  ContentManagement: {
    Title: "Quản lý bài viết",
    Total: "Tổng bài viết",
    Columns: {
      Name: "Tên bài viết",
      Preview: "Xem trước",
      Replace: "Thay bài viết",
      Download: "Tải bài viết",
      Delete: "Xóa bài viết",
      File: "Tệp bài viết",
      Image: "Hình ảnh",
    },
    Message: {
      WrongStructure: "File tải không đúng định dạng !",
      NotExisted: "File tải không tồn tại !",
      Files: "Vui lòng nhập ít nhất một file bài viết",
      OnlyDocx: "Lưu ý: Chỉ nhập file DOCX",
      OnlyImages: " Lưu ý: Chỉ nhập 1 file ảnh PNG, JPEG, JPG",
      MissingAttributes:
        "Vui lòng đặt tên có tiền tố Content đối với file DOC hoặc Image đối với file ảnh !",
      AddAttribute:
        "Vui lòng đặt tên file bài viết có tiền tố Content (Content_abc.docx), file hình ảnh có tiền tố Image (Image_xyz.png)",
    },
  },
  CountryManagement: {
    Title: "Quản lý quốc gia",
    Total: "Tổng quốc gia",
    Columns: {
      Name: "Tên quốc gia",
      Code: "Mã quốc gia",
      Capital: "Thủ đô",
      Region: "Vùng",
      Ensign: "Quốc kỳ",
    },
    Regions: {
      Americas: "Americas",
      Europe: "Europe",
      Asia: "Asia",
      Africa: "Africa",
      Oceania: "Oceania",
      Antarctica: "Antarctica",
    },
    Placeholder: {
      Capital: "Vui lòng nhập tên thủ đô",
      Region: "Vui lòng chọn vùng quốc gia",
      Cover: "Vui lòng nhập link hình ảnh dưới dạng URL",
    },
    RoamingPartner: {
      Name: "Tên đối tác",
      Code: "Mã đối tác",
    },
    MobileData: {
      Name: "Tên gói cước",
      Code: "Mã gói cước",
      Price: "Giá gói",
      Handset: "Handset",
      TransferredData: "Nhóm dữ liệu",
      CodeMobileDevice: "Code Mobile Device",
    },
    Message: {
      CoverAttributes: "Vui lòng đặt tên file cover có tiền tố Cover_",
      EnsignAttributes: "Vui lòng chọn một file ảnh quốc kỳ !",
    },
  },
  FileManagement: {
    Title: "Quản lý CDN",
    Upload: "Nhập File",
    Replace: "Thay file",
    Download: "Tải file",
    CopyUrl: "Sao chép URL",
    Placeholder: {
      Type: "Vui lòng chọn loại file",
      File: "Vui lòng nhập ít nhất 1 file từ máy tính",
      Url: "Đã lưu URL vào bộ nhớ tạm",
    },
    Columns: {
      Name: "Tên file",
      Code: "Mã file",
      Size: "Kích thước",
      Type: "Loại tệp",
    },
  },
  RoamingManagement: {
    Title: "Quản lý Gói Roaming",
    Total: "Tổng gói Roaming",
    Add: "Thêm",
    DetailInfo: "Thông tin chi tiết gói",
    RoamingPartnerInfo: "Thông tin đối tác Roaming",
    Category: {
      Hot: "Gói hot",
      Day: "Gói ngày",
      Week: "Gói tuần",
      Month: "Gói tháng",
      Roaming: "Gói Roaming",
    },
    PlaceHolder: {
      Cover: "Vui lòng nhập url hình ảnh...",
      Descriptions: "Vui lòng nhập mô tả...",
      ShortDes: "Vui lòng nhập mô tả ngắn gọn...",
      Duration: "Vui lòng nhập thời lượng gói...",
      Price: "Vui lòng nhập giá gói...",
      Storage: "Vui lòng nhập dung lượng gói...",
      DiscountRate: "Vui lòng nhập giảm giá...",
      InternalCallTotalHour: "Vui lòng nhập giờ gọi nội mạng...",
      ExternalCallTotalHour: "Vui lòng nhập giờ gọi ngoại mạng...",
      Category: "Vui lòng chọn loại gói...",
      Country: "Vui lòng chọn quốc gia...",
    },
    Country: {
      Title: "Quốc gia",
      Add: "Thêm quốc gia",
      Edit: "Chỉnh sửa thông tin quốc gia",
    },
    RoamingPartner: {
      Title: "Đối tác",
      Add: "Thêm đối tác",
      Select: "Chọn đối tác",
    },
    Columns: {
      Name: "Tên gói",
      Code: "Mã",
      Cover: "Hình ảnh",
      Description: "Mô tả",
      ShortDescription: "Mô tả ngắn gọn",
      Duration: "Thời lượng gói",
      Price: "Giá",
      Storage: "Dung lượng",
      DiscountRate: "Giảm giá",
      InternalCallTotalHour: "Giờ gọi nội mạng",
      ExternalCallTotalHour: "Giờ gọi ngoại mạng",
      Action: "Hành động",
      Country: "Quốc gia",
      Region: "Khu vực",
      Category: "Loại gói",
      Order: "Thứ tự",
      Type: "Loại",
      SimType: "Loại SIM",
      OnlyData: "Chỉ có data",
    },
  },
  TopupManagement: {
    Title: "Quản lý gói cước Data",
    Total: "Tổng gói cước",
    PriceRange: "Khoảng giá",
    Add: "Thêm thông tin",
    AddShort: "Thêm mô tả ngắn",
    AddMore: "Thêm thông tin mở rộng cho gói",
    More: "Thông tin mở rộng cho gói",
    MoreInfoName: "Tên thông tin",
    MoreInfoItems: "Thông tin",
    ShortDescription: "Mô tả ngắn",
    Order: "Theo độ ưu tiên",
    OnlyData: "Chỉ có Data ?",
    SimType: "Gói cho SIM ?",
    MoreWithTag: "Tag cho gói",
    TopLeftTitle: "Tiêu đề cho Tag",
    IsHot: "Là gói HOT ?",
    IsMobileTag: "Có Tag cho gói ?",
    Generals: "Thông tin gói",
    CountryInfo: "Quốc gia",
    Columns: {
      Name: "Tên gói",
      Code: "Mã gói",
      Order: "Độ ưu tiên",
      DurationDay: "Thời hạn",
      Price: "Giá gói",
      Storage: "Dung lượng",
      Category: "Danh mục gói",
      InternalCallTotalHour: "Gọi nội mạng",
      ExternalCallTotalHour: "Gọi ngoại mạng",
    },
    Category: {
      Hot: "Gói hot",
      Day: "Gói ngày",
      Week: "Gói tuần",
      Month: "Gói tháng",
    },
    Placeholder: {
      DurationDay: "Vui lòng nhập thời lượng gói",
      Price: "Vui lòng nhập giá gói thấp nhất 1,000 VNĐ !",
      Storage: "Vui lòng nhập dung lượng là số !",
      Cover: "Vui lòng nhập link dưới dạng URL !",
      Category: "Vui lòng chọn loại gói cước",
      DesAuto: "Nhập mô tả ngắn để có thể tự cập nhật mô tả",
      AutoUpdate: "Cập nhật cho cả Mô tả",
      RoamingIsRequired: "Chỉ có thể truy cập Quốc gia khi Loại là Roaming",
      UpdateCountry: "Tùy chỉnh thông tin Quốc gia cho gói Roaming",
      DuplicatedCode: "Mã gói cước nhà cung cấp này đã tồn tại",
    },
    SyncFromB2B: {
      Title: "Thêm gói data từ B2B",
      Confirm: "Bạn có chắc chắn muốn thêm các gói",
      InvalidPackages: "Vui lòng chọn một gói cước",
    },
    Service: {
      BuyPackage: "Data 4G/5G",
      TravelSim: "SIM Du lịch",
      SimEcommerce: "SIM Mobifone",
    },
  },
  TransactionHistory: {
    Title: "Lịch sử giao dịch gói cước",
    Total: "Tổng giao dịch",
    NoTransRef: "Không mã tham chiếu",
    Customer: "Khách hàng mua lẻ",
    Details: "Chi tiết giao dịch",
    StatusCheck: "Kiểm tra trạng thái",
    Message: {
      PartnerListError: "Lỗi danh sách đối tác",
    },
    Status: {
      Init: "Khởi tạo",
      Progerssing: "Đang xử lý",
      Finished: "Hoàn thành",
      Error: "Lỗi",
      Deleted: "Đã xóa",
      WaitingToBeConfirmed: "Chờ xác nhận",
    },
    Placeholder: {
      Code: "Nhập mã giao dịch",
      ID: "Nhập ID giao dịch",
      TransRef: "Nhập mã tham chiếu",
    },
    Columns: {
      ID: "ID giao dịch",
      Code: "Mã giao dịch",
      TransRef: "Mã tham chiếu",
      PackageName: "Gói cước",
      Phone: "Số điện thoại",
      Partner: "Đối tác",
      Method: "Phương thức",
      TotalAmount: "Tổng tiền",
    },
  },
  AddressManagement: {
    Title: "Quản lý Tỉnh thành",
    DataType: "Dữ liệu danh sách",
    Province: "Danh sách Tỉnh, Thành phố lớn",
    District: "Danh sách Quận, Huyện",
    Wards: "Danh sách Phường, Xã",
    Columns: {
      Name: "Tên",
      Code: "Mã",
      FullName: "Tên đầy đủ",
      FullNameEn: "Tên tiếng Anh đầy đủ",
      Province: "Tỉnh, thành phố lớn",
      District: "Quận, huyện",
      NameEn: "Tên tiếng Anh",
      Ward: "Phường, xã",
    },
    Placeholder: {
      Units: "Vui lòng chọn loại",
      Regions: "Vui lòng chọn vùng",
    },
  },
  ChangePassword: {
    Title: "Đổi mật khẩu",
    OldPass: "Mật khẩu cũ",
    NewPass: "Mật khẩu mới",
    Reconfirmed: "Xác nhận mật khẩu mới",
    Message: {
      InvalidPass: "Vui lòng xác nhận mật khẩu",
      OldPass: "Vui lòng nhập mật khẩu cũ",
      NewPass: "Vui lòng nhập mật khẩu mới",
      UnmatchedPass: "Mật khẩu xác nhận không trùng khớp",
      ChangePassSucceed: "Bạn đã đổi mật khẩu thành công !",
    },
  },
  SimOrdersForPartners: {
    Title: "Danh sách thông tin đăng ký Sim",
    Columns: {
      CreatedAt: "Thời gian tạo",
      OrderCode: "Mã đơn hàng",
      Sim: "Số Sim",
      PackageType: "Loại gói",
      CustomerName: "Tên khách hàng",
      CustomerPhone: "Số điện thoại khách hàng",
      Address: "Địa chỉ giao hàng",
      Email: "Email khách hàng",
      Partner: "Đối tác",
    },
    Status: {
      WaitingForPurchased: "Chờ thanh toán",
      WaitingForDelivered: "Chờ giao hàng",
      WaitingForRecieved: "Chờ nhận hàng",
      Success: "Giao hàng thành công",
      Canceled: "Đã hủy",
      ConnectedSuccessfully: "Hòa mạng thành công",
      ConnectedFailed: "Hòa mạng thất bại",
    },
    Message: {
      ExcelError: "Lỗi xuất báo cáo",
      InvalidSim: "Số sim không được để trống",
      InvalidPackages: "Nhập số sim để hiện thông tin gói",
      InvalidOrderCode: "Mã đơn hàng không để trống",
      InvalidPhone: "Điện thoại liên hệ không được trống hoặc quá 10 số !",
      Address: "Vui lòng nhập địa chỉ khách hàng",
    },
  },
  TravelSimListManagement: {
    Title: "Danh sách thông tin đăng ký sim du lịch",
    Placeholder: "Vui lòng nhập ",
    Detail: "Thông tin chi tiết",
    Gender: {
      Male: "Nam",
      Female: "Nữ",
    },
    Labels: {
      Status: "Trạng thái",
      Type: "Loại",
      Name: "Tên khách hàng",
      ProfileId: "Mã hồ sơ",
      Serial: "Số serial",
      Sim: "Số sim",
      Detail: "Chi tiết",
      Time: "Thời gian tạo",
      IdNumber: "Mã định danh",
      Birthday: "Ngày sinh",
      Sex: "Giới tính",
      Address: "Địa chỉ",
      PlaceOfOrigin: "Quê quán",
      IssueDate: "Ngày cấp",
      IssuePlace: "Nơi cấp",
      PhoneContact: "Số điện thoại",
      EmailContact: "Email",
      ImagesPath: "Các loại giấy tờ",
    },
    ImagePaths: {
      portrait: "Ảnh chân dung",
      front: "Mặt trước",
      back: "Mặt sau",
      sign: "Chữ ký",
    },
    Status: {
      init: "Khởi tạo",
      isOCR: "Đã OCR",
      verified: "Đã xác thực",
      progress: "Đang xử lý",
      success: "Thành công",
      error: "Thất bại",
    },
    Type: {
      cccd: "CCCD",
      passport: "Hộ chiếu",
    },
  },
  RoamingRegistration: {
    Title: "Đăng ký gói cước cho User",
    ModalTitle: "Đăng ký gói cước cho thuê bao",
    Action: "Chọn gói",
    Phone: "Thuê bao cần đăng ký",
    Register: "Đăng ký",
    AddToList: "Thêm vào danh sách đăng ký",
    AssingedList: "Danh sách đăng ký",
    PhoneRegisteredListColumns: {
      Name: "Tên khách hàng",
      Phone: "Thuê bao đăng ký",
      Address: "Địa chỉ",
      Price: "Tổng tiền",
      Email: "Email",
    },
    Columns: {
      Name: "Tên gói",
      Code: "Mã gói",
      Type: "Loại gói",
      Duration: "Thời hạn",
      Capacity: "Dung lượng",
      Price: "Giá gói",
      PartnerTransId: "Mã tham chiếu của đối tác",
    },
    Placehoder: {
      Phone: "Vui lòng nhập số điện thoại...",
    },
    Message: {
      Success: "Đăng ký gói cước thành công",
      Failed: "Đăng ký gói cước cho thuê bao thất bại",
      Error: "Có lỗi xảy ra",
      InvalidPackageAndPhone:
        "Vui lòng chọn một gói cước và nhập thuê bao cần đăng ký để đi tiếp !",
      InvalidPackage: "Vui lòng chọn một gói cước !",
      InvalidPhone: "Vui lòng nhập số thuê bao cần đăng ký gói !",
      RegisterSuccessfully: "Đăng ký gói cước cho thuê bao thành công !",
      PhoneRegistrationWarning:
        "Đây là danh sách tham khảo, vui lòng tìm kiếm với số thuê bao cần đăng ký để hiện danh sách gói phù hợp",
      PhoneRegistrationConfirm: "Xác nhận đăng ký gói",
      ForPhone: "cho thuê bao",
      BasePackagesExisted: "Thuê bao cần đăng ký đang có gói nền",
      RemoveBasePackages: "vui lòng hủy gói nền trước khi đăng ký gói mới !",
      PackagesForSearchedPhone: "Danh sách gói cước cho thuê bao",
      NotMobifone: "Thuê bao không thuộc đầu số Mobifone, vui lòng thử lại !",
      EmptyAssignedList: "Danh dách đăng ký đang rỗng !",
      InvalidPartnerTransId: "Vui lòng nhập mã tham chiếu đối tác !",
      InvalidPhoneLength: "Vui lòng nhập số điện thoại đủ 10 số !",
    },
  },
  BalanceHistory: {
    Title: "Lịch sử điều chỉnh số dư",
    Approve: "Duyệt",
    Reject: "Từ chối",
    Add: "Tạo phiếu",
    Type: {
      0: "Phiếu tăng",
      1: "Phiếu giảm",
    },
    Status: {
      0: "Đang chờ duyệt",
      1: "Duyệt",
      2: "Từ chối",
    },
    ApplicableType: {
      0: "Người dùng",
      1: "Đối tác",
    },
    Placeholder: {
      Type: "Vui lòng chọn loại phiếu",
      ApplicableType: "Vui lòng chọn đối tượng áp dụng",
      Amount: "Vui lòng nhập số tiền yêu cầu ít nhất 1000 VNĐ",
      Phone:
        "Chọn đối tượng áp dụng và người dùng hoặc đối tác để lấy số điện thoại",
      Partner: "Vui lòng chọn một đối tác",
      User: "Vui lòng chọn một người dùng",
    },
    Columns: {
      code: "Mã",
      phone: "Số điện thoại",
      before: "Số dư trước khi duyệt",
      after: "Số dư sau khi duyệt",
      amount: "Số tiền yêu cầu",
      balance: "Số dư ví",
      applicableType: "Đối tượng áp dụng",
      type: "Loại",
      status: "Trạng thái",
      createdBy: "Người tạo",
      updatedBy: "Người duyệt",
      description: "Mô tả",
      createdAt: "Ngày tạo",
      updatedAt: "Ngày cập nhật",
    },
    Message: {
      CreateSuccessfully: "Tạo phiếu thành công !",
      CreateFailed: "Tạo phiếu thất bại !",
      ApproveSuccessfully: "Duyệt phiếu thành công !",
      ApproveFailed: "Duyệt phiếu thất bại",
      RejectSuccessfully: "Từ chối phiếu thành công !",
      RejectFailed: "Từ chối phiếu thất bại",
    },
  },
  PartnerManagement: {
    Normal: "Normal",
    MainTitle: "Quản lý đối tác",
    ipnUrl: "IPN Url",
    Total: "Tổng đối tác",
    CreateUserAfter:
      "Sau khi tạo đối tác thành công, sẽ tự động tạo một thông tin người dùng cho đối tác đó",
    UserPartner: "Thông tin người dùng cho đối tác",
    CopyUserInfo: "Đã lưu thông tin người dùng của đối tác vào bộ nhớ tạm",
    Columns: {
      name: "Tên đối tác",
      code: "Mã đối tác",
      email: "Email",
      phone: "Số điện thoại",
      balance: "Số dư",
      type: "Loại",
      status: "Trạng thái",
      affiliateUrl: "Đường dẫn Affiliate",
      createdAt: "Ngày tạo",
    },
    Filters: {
      name: "Tên đối tác",
      code: "Mã đối tác",
      email: "Email",
      phone: "Số điện thoại",
      type: "Loại",
      status: "Trạng thái",
    },
    Detail: {
      id: "ID",
      name: "Tên đối tác",
      code: "Mã đối tác",
      email: "Email",
      phone: "Số điện thoại",
      type: "Loại",
      status: "Trạng thái",
      publicKey: "Khóa đối tác",
      whnSupplierCode: "Mã nhà cung cấp WHN",
      token: "Token",
      affiliateUrl: "Đường dẫn Affiliate",
      icon: "Đường dẫn Icon",
      address: "Địa chỉ",
      ipnUrl: "Đường dẫn IPN",
    },
    Placeholder: {
      SavedPass: "Đã lưu mật khẩu vào bộ nhớ tạm",
      SavesName: "Đã lưu tên tài khoản vào bộ nhớ tạm",
    },
    UserInfo: {
      userName: "Tên tài khoản",
      password: "Mật khẩu",
      phone: "Số điện thoại",
      address: "Địa chỉ",
      balance: "Số dư",
      type: "Loại",
      status: "Trạng thái",
    },
  },
  RoamingPartner: {
    Active: {
      0: "Roaming",
    },
    Label: "Đối tác Roaming",
    CountryList: "Danh sách quốc gia",
    MobileDataList: "Danh sách nhà mạng",
    Columns: {
      createdAt: "Ngày tạo",
      updatedAt: "Ngày cập nhật",
      id: "ID đối tác",
      code: "Mã đối tác",
      name: "Tên đối tác",
      email: "Email",
      phone: "Số điện thoại",
      address: "Địa chỉ",
      type: "Loại",
      active: "Tình trạng kích hoạt",
      url: "Đường dẫn",
      order: "Order",
    },
    Filters: {
      name: "Tên đối tác",
      code: "Mã đối tác",
      email: "Email",
      phone: "Số điện thoại",
      type: "Loại",
      active: "Tình trạng kích hoạt",
    },
    Detail: {
      id: "ID",
      name: "Tên đối tác",
      code: "Mã đối tác",
      email: "Email",
      phone: "Số điện thoại",
      type: "Loại",
      active: "Tình trạng kích hoạt",
      order: "Order",
      url: "Đường dẫn",
      address: "Địa chỉ",
    },
  },
  AppProfileRegister: {
    Title: "Lịch sử đăng ký hồ sơ app",
    Labels: {
      ApprovedBy: "Người duyệt",
      DetailProfile: "Chi tiết hồ sơ",
      VerifyProfile: "Duyệt hồ sơ",
      AcceptProfile: "Chấp nhận hồ sơ",
      AcceptConfirm: "Bạn có muốn chấp nhận hồ sơ này?",
      DenyProfile: "Từ chối hồ sơ",
      DenyConfirm: "Bạn có muốn từ chối hồ sơ này?",
      RejectReason: "Lý do từ chối",
      SignProfile: "Ký hồ sơ",
      Id: "ID hồ sơ",
      Status: "Trạng thái",
      Type: "Loại hợp đồng",
      Name: "Tên hồ sơ",
      Code: "Mã hồ sơ",
      Time: "Thời gian tạo",
      UpdatedTime: "Thời gian cập nhật",
      ProviderCode: "Mã định danh hồ sơ",
      ProviderPreviewCode: "Mã hồ sơ nhà cung cấp",
      PhoneNumber: "Số điện thoại",
      ExpriedAt: "Ngày hết hạn hợp đồng",
      ExpriedSignDate: "Ngày hết hạn ký",
      VerifiedStatus: "Trạng thái xác thực",
      IsVerified: "Đã xác thực",
      NotVerified: "Chưa xác thực",
      File: "Tài liệu",
      SyncStatus: "Đồng bộ trạng thái hồ sơ",
      SyncAllStatus: "Đồng bộ trạng thái tất cả hồ sơ",
      Organization: {
        Name: "Tổ chức",
        Address: "Địa chi",
        Email: "Email",
        TaxCode: "Mã số thuế",
        Bank: "Ngân hàng",
        RepresentativeName: "Người đại diện",
        RepresentativeRole: "Chức vụ",
        BusinessCerts: "GPĐK kinh doanh",
      },
      Participants: {
        Title: "Thành viên tham gia",
        Name: "Họ tên user",
        Address: "Địa chỉ",
        Email: "Email",
        TaxCode: "Mã số thuế",
        Bank: "Ngân hàng",
        BankAccount: "Số tài khoản",
        Single: "Cá nhân",
        Organization: "Tổ chức",
        Code: "Mã người dùng",
        RecipentCode: "Mã người dùng nhà cung cấp",
        PhoneNumber: "Số điện thoại",
        Type: "Loại",
        Status: "Trạng thái user ký",
        Images: "Hình ảnh",
        IDNumber: "CCCD",
        IdIssueDate: "Ngày cấp",
        IdIssuePlace: "Nơi cấp",
      },
      AssetsClassify: {
        Avatar: "Ảnh đại diện",
        BusinessCerts: "GPĐK kinh doanh",
        Contract: "Hợp đồng",
        IdCard: "CCCD",
        Default: "Hình ảnh",
      },
      Reason: "Lý do",
    },
    Messages: {
      ConfirmAcceptProfile: "Bạn có chắc muốn duyệt hồ sơ này?",
      ConfirmDenyProfile: "Bạn có chắc muốn từ chối hồ sơ này?",
      ConfirmSignProfile: "Bạn có chắc muốn ký hồ sơ?",
    },
    Status: {
      Init: "Khởi tạo",
      Proccessing: "Đang chờ ký",
      Approving: "Đang chờ duyệt",
      Approved: "Đã duyệt",
      Completed: "Hoàn thành",
      Rejected: "Từ chối",
      Cancel: "Đã hủy",
      Signed: "Đã ký",
      Expried: "Hết hạn",
    },
    Type: {
      Verified: "Hợp đồng hợp tác",
    },
  },
  AppTransactionHistory: {
    AppPhoneRechargeTitle: "Nạp tiền điện thoại",
    AppSimMobifoneTitle: "SIM",
    AppDataRegisterTitle: "Gói cước",
    AppNiceSimTitle: "SIM số đẹp",
    AppTravelSimTitle: "SIM du lịch",
    InboundTravelSimTitle: "SIM Hello Vietnam",
    OutboundTravelSimTitle: "SIM Let's go",
    ExportReportTiTle: "Xuất báo cáo lịch sử giao dịch",
    TransactionHistory: "Lịch sử giao dịch",
    ExportSuccess: "Xuất báo cáo thành công",
    Labels: {
      DetailTrans: "Chi tiết giao dịch",
      Status: "Trạng thái",
      Type: "Loại",
      Name: "Tên sản phẩm",
      PackageCode: "Mã gói",
      SimCode: "Sim",
      Code: "Mã giao dịch",
      Time: "Thời gian",
      Service: "Dịch vụ",
      Product: "Sản phẩm",
      ProductCode: "Mã sản phẩm",
      ProductPrice: "Giá sản phẩm",
      PhoneNumber: "Số điện thoại",
      IccidNumber: "Số ICCID",
      IsdnOrIccid: "Số điện thoại/ICCID",
      PaymentMethod: "Phương thức",
      NumberType: "Loại số",
      Total: "Số tiền",
      TransRef: "Mã tham chiếu",
      Platform: "Nền tảng",
      Description: "Mô tả",
      RefundReason: "Lý do hoàn tiền",
      NumberTypeOps: {
        MEMORABLE_PHYSICAL: "Số dễ nhớ",
        THREE_7_PHYSICAL: "Tam hoa 7",
        THREE_8_PHYSICAL: "Tam hoa 8",
        THREE_9_PHYSICAL: "Tam hoa 9",
        AB_BA_PHYSICAL: "Cặp số AB_BA",
        AB_AB_PHYSICAL: "Cặp số AB_AB",
        AA_BB_PHYSICAL: "Cặp số AA_BB",
      },
      AmountLabel: {
        product: "Sản phẩm",
        discount: "Giảm giá",
        userTax: "Thuế",
        discountRate: "Chiết khấu",
        package: "Gói",
        simAdvance: "Phí giữ sim",
      },
      BuyerName: "Khách hàng",
      BuyerEmail: "Email",
      BuyerPhone: "Số điện thoại",
      BuyerAddress: "Địa chỉ",
      UserName: "Người thực hiện",
      UserCode: "Mã người dùng",
      ProductLabels: {
        SimNumber: "Số Sim",
        SimPrice: "Giá Sim",
        SimType: "Loại SIM",
        PackageName: "Gói cước",
        PackageCode: "Mã gói",
        PackagePrice: "Giá gói",
        Storage: "Dung lượng",
        Duration: "Thời hạn",
        Serial: "Số serial",
        Code: "Mã SP",
        Price: "Giá SP",
      },
    },
    Status: {
      Init: "Khởi tạo",
      Process: "Đang xử lý",
      Success: "Thành công",
      Failed: "Thất bại",
      Pending: "Chờ thanh toán",
      PaymentSuccess: "Thanh toán thành công",
      Timeout: "Đang treo",
      Deleted: "Đã xóa",
      Refund: "Hoàn tiền",
    },
    Type: {
      Normal: "Mặc định",
      User: "Cá nhân",
      Partner: "Pháp nhân",
    },
    TransactionDetail: {
      createdAt: "Ngày tạo",
      updatedAt: "Ngày cập nhật",
      name: "Tên giao dịch",
      code: "Mã giao dịch",
      transRef: "Mã tham chiếu",
      phoneNumber: "Số điện thoại",
      status: "Trạng thái",
      totalPrice: "Tổng tiền",
      serial: "ICCID",
      numberType: "Loại số",
      simType: "Loại SIM",
      type: "Loại giao dịch",
      carrier: "Nhà mạng",
      package: "Gói cước",
      beforeCredit: "Số dư trước giao dịch",
      afterCredit: "Số dư sau giao dịch",
      description: "Lý do lỗi",
      buyerName: "Tên khách hàng",
      buyerEmail: "Email khách hàng",
      buyerPhone: "Số điện thoại liên hệ",
      buyerAddress: "Địa chỉ khách hàng",
    },
    ExportReportTransaction: {
      Title: "Xuất báo cáo giao dịch",
    },
  },
  UserAppManagement: {
    Title: "Quản lý người dùng app",
    Label: {
      DetailInfo: "Thông tin chi tiết",
      Address: "Địa chỉ",
      CreatedTime: "Thời gian tạo",
      Id: "ID",
      UserName: "Tên username",
      FullName: "Họ tên",
      Email: "Email",
      Partner: "Đối tác",
      Phone: "Số điện thoại",
      Balance: "Số dư",
      Role: "Role user",
      Birthday: "Ngày sinh",
      Description: "Mô tả",
      TaxCode: "Mã số thuế",
      LatestContract: "Hồ sơ xác thực",
      ResetOTP: "Đặt lại OTP",
    },
  },
  TravelSimProfileRegister: {
    Title: "Đăng ký sim du lịch",
    Status: {
      Init: "Khởi tạo",
      InProgress: "Đang xử lý",
      Success: "Thành công",
      Error: "Lỗi",
      Confirm: "Đã xác nhận",
      Connect: "Đã kết nối",
      Approve: "Đã duyệt",
    },
    Detail: {
      Buyer: "Người tạo đơn",
      Sim: "Số SIM",
      BuyerEmail: "Email liên lạc",
      BuyerPhone: "SĐT liên lạc",
      BuyerCode: "Mã tài khoản",
      Serial: "Số Serial",
      Time: "Thời gian",
      Title: "Chi tiết GD",
      Code: "Mã",
      IdNumber: "Số Passport",
      Status: "Trạng thái",
      Nationality: "Quốc tịch",
      CodeNumber: "Mã số",
      PlaceOfOrigin: "Nơi sinh",
      IssueDate: "Ngày cấp",
      IssuePlace: "Nơi cấp",
      Profile: "Hồ sơ",
      ExpiryDate: "Ngày hết hạn",
      Note: "Ghi chú",
      DialCode: "Mã quốc gia",
      Documents: "Tài liệu",
      Front: "Mặt trước",
      Back: "Mặt sau",
      Portrait: "Chân dung",
      Sign: "Chữ ký",
      VideoCall: "Video call",
      FrontDownscale: "Mặt trước (thu nhỏ)",
      PortraitDownscale: "Chân dung (thu nhỏ)",
      VideoCallDownscale: "Video call (thu nhỏ)",
      Contract: "Hợp đồng",
      Policy: "Chính sách",
    },
    ImagePaths: {
      portrait: "Ảnh chân dung",
      videocall: "Videocall",
      front: "Mặt trước",
      back: "Mặt sau",
      sign: "Chữ ký",
      sim: "Sim",
      contractId: "Hợp đồng",
      policyId: "Điều khoản bảo mật",
      frontDownscaleId: "Mặt trước thu nhỏ",
      portraitDownscaleId: "Chân dung thu nhỏ",
      videocallDownscaleId: "Video call thu nhỏ",
    },
  },
  PaymentMethod: {
    Label: "Quản lý phương thức thanh toán",
    Total: "Tổng số phương thức thanh toán",
    Columns: {
      id: "ID phương thức",
      name: "Tên phương thức",
      displayName: "Tên hiển thị",
      code: "Mã phương thức",
      type: "Loại",
      status: "Trạng thái",
      order: "Order",
    },
    Filters: {
      name: "Tên phương thức",
      code: "Mã phương thức",
      displayName: "Tên hiển thị",
      type: "Loại",
      status: "Trạng thái",
    },
    Detail: {
      id: "ID",
      name: "Tên phương thức",
      code: "Mã phương thức",
      status: "Trạng thái",
      type: "Loại",
      displayName: "Tên hiển thị",
      supplier: "Nhà cung cấp",
      cover: "Hình ảnh",
      description: "Mô tả",
      url: "Đường dẫn",
      order: "Order",
    },
    Active: {
      1: "Ngân hàng",
      2: "Ví điện tử",
    },
  },
  SupplierManagement: {
    Label: "Quản lý nhà cung cấp",
    Total: "Tổng nhà cung cấp",
    Code: "Mã gói cước nhà cung cấp",
    Columns: {
      id: "ID nhà cung cấp",
      name: "Tên nhà cung cấp",
      displayName: "Tên hiển thị",
      email: "Email",
      phoneNumber: "Số điện thoại",
      address: "Địa chỉ",
      type: "Loại",
      status: "Trạng thái",
    },
    Filters: {
      name: "Tên nhà cung cấp",
      displayName: "Tên hiển thị",
      email: "Email",
      phoneNumber: "Số điện thoại",
      type: "Loại",
      status: "Trạng thái",
    },
    Detail: {
      id: "ID",
      name: "Tên nhà cung cấp",
      status: "Trạng thái",
      type: "Loại",
      displayName: "Tên hiển thị",
      email: "Email",
      phoneNumber: "Số điện thoại",
      address: "Địa chỉ",
      cover: "Hình ảnh",
      image: "Ảnh",
      description: "Mô tả",
      order: "Order",
    },
    Active: {
      0: "Mặc định",
      1: "Thanh toán",
      2: "OCR",
    },
  },
  AirTimeManagement: {
    Label: "Quản lý mệnh giá nạp điện thoại",
    Total: "Tổng số mệnh giá nạp điện thoại",
    Columns: {
      id: "ID mệnh giá",
      name: "Tên mệnh giá",
      code: "Mã mệnh giá",
      amount: "Số tiền",
      type: "Loại",
      status: "Trạng thái",
    },
    Filters: {
      name: "Tên mệnh giá",
      code: "Mã mệnh giá",
      amount: "Số tiền",
      status: "Trạng thái",
    },
    Detail: {
      name: "Tên mệnh giá",
      code: "Mã mệnh giá",
      amount: "Số tiền",
      status: "Trạng thái",
      type: "Loại",
      carrier: "Carrier",
      config: "Cấu hình",
      description: "Mô tả",
    },
    Supplier: {
      name: "Tên nhà cung cấp",
      displayName: "Tên hiển thị",
      address: "Địa chỉ",
      email: "Email",
      phoneNumber: "Số điện thoại",
      description: "Mô tả",
    },
    Type: {
      0: "Thẻ điện thoại",
    },
  },
  DiscountManagement: {
    Title: "Quản lý chiết khấu",
    CreateDiscount: "Tạo chiết khấu",
    UpdateDiscount: "Cập nhật chiết khấu",
    Columns: {
      id: "ID",
      createdAt: "Ngày tạo",
      updatedAt: "Ngày cập nhật",
      name: "Tên chiết khấu",
      code: "Mã chiết khấu",
      type: "Loại chiết khấu",
      order: "Order",
      note: "Ghi chú",
      discountRate: "Chiết khấu",
      parentId: "Thuộc nhóm chiết khấu",
      service: "Dịch vụ",
      group: "Nhóm sản phẩm",
      product: "Sản phẩm",
      parent: "Chiết khấu cha",
      parentCode: "Mã chiết khấu cha",
      parentRate: "Mức chiết khấu cha",
      AddNewUser: "Thêm người dùng",
    },
    Filters: {
      status: "Trạng thái",
      type: "Loại",
      user: "Người dùng",
      service: "Dịch vụ",
      group: "Nhóm sản phẩm",
    },
    Messages: {
      Required: "Vui lòng điền thông tin này",
    },
  },
  SimManagement: {
    Title: "Quản lý Sim",
    DownloadTemplate: "Tải mẫu nhập sim",
    UploadFile: "Upload phiếu nhập sim",
    ImportSim: "Nhập sim",
    ImportTable: "Nhập sim trực tiếp",
    ImportFile: "Nhập sim từ file",
    ImportSuccess: "Nhập sim thành công",
    AddRow: "Thêm hàng",
    QuickUpdate: "Bạn có muốn cập nhật nhanh không?",
    ErrorMessage1: "Phiếu bạn vừa nhập hiện có",
    ErrorMessage2: "dòng bị lỗi",
    SimDetail: "Thông tin Sim",
    Status: {
      Active: "Khả dụng",
      Inactive: "Không khả dụng",
      Sold: "Đã bán",
      Deleted: "Đã xóa",
    },
    SimType: {
      Physical: "SIM Vật lý",
      ESim: "eSIM",
    },
    Fields: {
      Code: "Mã định danh",
      Name: "Tên hiển thị",
      Serial: "Serial",
      PhoneNumber: "Số sim",
      Status: "Trạng thái",
      Type: "Dịch vụ",
      SimType: "Loại SIM",
      SKU: "Mã SKU",
      Zodiac: "Cung hoàng đạo",
      Numerology: "Thần số học",
      Destiny: "Mệnh",
      Description: "Mô tả",
      ShortDescription: "Mô tả ngắn",
    },
  },
  SupportFeature: {
    MainTitle: "Hỗ trợ",
    PackageLookup: {
      Title: "Tra cứu gói cước",
      Input: {
        Placeholder: "Nhập số thuê bao",
      },
      Output: {
        StartDate: "Ngày kích hoạt",
        EndDate: "Ngày kết thúc",
        Capacity: "Dung lượng",
        UsedCapacity: "Dung lượng đã sử dụng",
        RemaingCapacity: "Dung lượng còn lại",
        Package: "Tên gói cước",
        PackageCapacity: "Dung lượng gói cước",
        NotFound: "Số điện thoại chưa đăng ký gói cước",
      },
    },
    SimLookup: {
      Title: "Tra cứu SIM",
      Input: {
        Placeholder: "Nhập số thuê bao/ICCID",
        QRCode: "QRCode SIM",
      },
      Output: {
        isActivated: "SIM đã được kích hoạt",
        isUnactivated: "SIM chưa được kích hoạt",
      },
      Message: {
        NumberOrQr:
          "Vui lòng Nhập số điện thoại/ICCID hoặc tải ảnh QRCode SIM.",
      },
    },
    ApiDoc: {
      Title: "Tài liệu hỗ trợ API",
    },
    Dispatch: {
      Title: "Văn bản",
    },
  },
  CashFlow: {
    MainTitle: "Dòng tiền",
    Columns: {
      TransCode: "Mã giao dịch",
      CostIn: "Tiền vào",
      CostOut: "Tiền ra",
      Wallet: "Số dư cuối",
      Content: "Nội dung",
    },
    Filters: {
      Type: "Nội dung",
      Code: "Mã giao dịch",
      Debit: "Trừ tiền",
      Withdraw: "Rút tiền",
      Deposit: "Nạp tiền",
      Refund: "Hoàn tiền",
    },
  },
  StaffManagement: {
    Title: "Quản lý tài khoản",
    MainTitle: "Người dùng",
  },
};
